import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from 'app/base';
import { TelefoneTipo, Hipoteses, EnderecoTipo } from '../../../entity/enumeraveis';

@Component({
    selector: 'prestacao-conta-etapa1',
    templateUrl: './prestacao-conta-etapa1.component.html',
})
export class CrudPrestacaoContaEtapa1Component extends BaseStepComponent {
    @Input() listaTelefones: any[] = [];
    @Input() listaEmails: any[] = [];
    @Input() listaEnderecos: any[] = [];
    @Input() funcaoExercida: SelectItem[] = [];
    @Input() listaFuncao: any[] = [];
    @Input() hipoteses: SelectItem[] = [];
    @Input() hipotesesLabel: string;
    @Input() validateForm: any = false;
    @Input() todasHipoteses: any[];
    @Input() profissional: any;
    @Output() validateFormChange = new EventEmitter<any>();
    @Output() listaTelefonesChange = new EventEmitter<any[]>();
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    @Output() listaFuncaoChange = new EventEmitter<any>(true);
    @Output() hipotesesLabelChange = new EventEmitter<any>();
    labelEndereco = "Endereços secundários";
    labelTelefone = "Telefones secundários";
    labelEmail = "Emails secundários";
    hipotesesEnum = Hipoteses;
    telefoneTipo = TelefoneTipo;
    listaTipoLogradouro: any[];
    enderecoTipo = EnderecoTipo;
    listaUF: any[];

    init() {
        this.stepObject.emit(this);
        this.service.ListarTodos('combo/tipo_logradouro').subscribe(
            data => this.listaTipoLogradouro = data
        );
        this.emitValidation(true);

        this.hipotesesLabel = this.hipotesesEnum[0];

        this.cadastro.get("funcao_hipotese.id_funcao_exercida").valueChanges.subscribe(data => {
            this.hipotesesLabel = this.hipotesesEnum[data];
            this.hipotesesLabelChange.emit(this.hipotesesLabel);
        });
    }

    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        }
        else {
            if (this.listaFuncao.length > 0) {
                this.isValid = true;
            } else {
                this.isValid = false;
                this.validateForm = [this.cadastro.get("funcao_hipotese")];
                this.showMsg('warn', 'Prestação de conta', 'É necessário informar ao menos uma Função Exercida.');
            }
        }
        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
    }
}


// WEBPACK FOOTER //
// ./src/app/prestacao-conta/crud/etapas/prestacao-conta-etapa1.component.ts